<div class="table-responsive pt-2">
    <table class="table table-hover table-bordered-outside">
        <thead class="border-0">
            @if(selectionEnabled){<th></th>}
            <th class="row p-0 hide-for-mobile">
                <div class="col-md-6 p-0"></div>
                <div class="col-md-3 py-0">Role(s)</div>
                @if(hasTags()){
                <div class="col-md-3 py-0">Tag(s)</div>
                }
            </th>
            <th></th>
            <th></th>
        </thead>
        <tbody>
            @for (member of members; track member.id){
                <tr class="media media-hover">
                    @if(selectionEnabled){
                        <td class="align-middle" [ngClass]="isMemberActive(member)">
                            <div class="checkbox">
                                <label>
                                    <input type="checkbox" [(ngModel)]="member.checked" (change)="check()">
                                </label>
                            </div>
                        </td>
                    }
                  
                    <td (click)="editMember(member)" [ngClass]="isMemberActive(member)">
                        <team-member [member]="member"></team-member>
                    </td>

                    @if(moveEnabled && isUserAdminOfMultipleTeams){
                        <td class="align-middle team-member-list-action" [ngClass]="isMemberActive(member)">
                            <button class="btn btn-default px-3" (click)="openMoveModal(team, member)">
                                <i class="far fa-share"></i> {{'move'|translate}}
                            </button>
                        </td>
                    }

                    <td class="align-middle team-member-list-action" [ngClass]="isMemberActive(member)">
                        <button class="btn btn-default px-3" (click)="editMember(member)">
                            <i class="far fa-pen pe-1"></i> {{'edit'|translate}}
                        </button>
                    </td>
                </tr>
            }
        </tbody>
    </table>
</div>